import { DropoffGateModel } from "./DropoffGate.model";

export class DropoffGate extends DropoffGateModel {
    // Add custom methods here
}
